window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

if (window.location.href.includes("/products/")) {
  document.querySelectorAll(".bundle-card > .bundle-card__content").forEach((card) => {
    const linkElement = card.querySelector("fieldset > a");
    const selectElement = card.querySelector('select[name="selling_plan"]');
    const updateLink = () => {
      let url = new URL(linkElement.href);
      url.searchParams.delete("product");
      url.searchParams.set("selling_plan", selectElement.value);
      linkElement.href = url.toString();
    };

    updateLink();
    selectElement.addEventListener("change", updateLink);
  });
}
